import React, { SVGProps } from 'react'
const SvgOrganizationBuildingIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={147}
    height={126}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FCFCFF"
      d="M125.577 84.928c38.923-14.167 58.826-57.663 44.454-97.15-14.372-39.488-57.577-60.014-96.5-45.847C34.608-43.903 14.705-.407 29.078 39.08c14.372 39.487 57.576 60.013 96.499 45.847Z"
    />
    <path
      fill="#F6F7FB"
      d="M125.577 84.928c38.923-14.167 58.826-57.663 44.454-97.15-14.372-39.488-57.577-60.014-96.5-45.847C34.608-43.903 14.705-.407 29.078 39.08c14.372 39.487 57.576 60.013 96.499 45.847Z"
    />
    <g
      fillRule="evenodd"
      clipRule="evenodd"
      filter="url(#OrganizationBuildingIcon_svg__a)"
    >
      <path
        fill="#fff"
        d="M168.179-7.55 110.133 1.2l26.766 73.54h.002l2.233 6.133 52.79-19.214a6.866 6.866 0 0 0 4.103-8.799L177.888 3.023a8.16 8.16 0 0 0-.061-.16l-2.174-5.973a6.864 6.864 0 0 0-7.474-4.44Z"
      />
      <path
        fill="url(#OrganizationBuildingIcon_svg__b)"
        d="M168.179-7.55 110.133 1.2l26.766 73.54h.002l2.233 6.133 52.79-19.214a6.866 6.866 0 0 0 4.103-8.799L177.888 3.023a8.16 8.16 0 0 0-.061-.16l-2.174-5.973a6.864 6.864 0 0 0-7.474-4.44Z"
      />
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m139.375 40.762 10.537-3.835"
      opacity={0.7}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m144.574 55.066 10.537-3.835"
      opacity={0.5}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m133.883 25.707 10.536-3.835"
      opacity={0.4}
    />
    <g filter="url(#OrganizationBuildingIcon_svg__c)">
      <path
        fill="url(#OrganizationBuildingIcon_svg__d)"
        fillRule="evenodd"
        d="M95.276-23.121 17.566-9.816A6.865 6.865 0 0 0 12.274-.7L48.75 99.519l.06.16 2.174 5.972a6.865 6.865 0 0 0 8.8 4.103l79.346-28.88-34.01-93.444a8.053 8.053 0 0 0-.061-.16l-2.174-5.972a6.865 6.865 0 0 0-7.61-4.419Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F6F7FB"
      fillRule="evenodd"
      d="m79.732 69.218 13.654-4.97c3.563-1.296 7.828 1.434 9.525 6.098l7.633 20.971-26.556 9.666-7.633-20.972c-1.698-4.664-.186-9.496 3.377-10.793Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m55.559 54.66 12.902-4.696M48.52 35.309l12.902-4.696"
      opacity={0.7}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m41.473 15.957 12.902-4.696"
      opacity={0.3}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="m88.246 42.77 12.902-4.697"
      opacity={0.4}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="M81.2 23.418 94.1 18.722"
      opacity={0.3}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={6.865}
      d="M74.164 4.059 87.066-.637"
      opacity={0.7}
    />
    <defs>
      <linearGradient
        id="OrganizationBuildingIcon_svg__b"
        x1={138.853}
        x2={104.915}
        y1={80.107}
        y2={-23.106}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F3FDD" />
        <stop offset={1} stopColor="#588AF3" />
      </linearGradient>
      <linearGradient
        id="OrganizationBuildingIcon_svg__d"
        x1={53.011}
        x2={11.452}
        y1={112.325}
        y2={-18.889}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FCEB6" />
        <stop offset={1} stopColor="#588AF2" />
      </linearGradient>
      <filter
        id="OrganizationBuildingIcon_svg__a"
        width={108.049}
        height={110.24}
        x={99.263}
        y={-14.149}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.348} />
        <feGaussianBlur stdDeviation={5.435} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7743_33953"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7743_33953"
          result="shape"
        />
      </filter>
      <filter
        id="OrganizationBuildingIcon_svg__c"
        width={149.011}
        height={155.129}
        x={0.988}
        y={-29.742}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.348} />
        <feGaussianBlur stdDeviation={5.435} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7743_33953"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7743_33953"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgOrganizationBuildingIcon
